import Placeholder from '@/components/core/Placeholder';
import HeroBio from '@/components/layouts/Hero//bio';
import HeroBasic from '@/components/layouts/Hero/basic';
import HeroHome from '@/components/layouts/Hero/home';
import HeroProject from '@/components/layouts/Hero/project';
import HeroRaw from '@/components/layouts/Hero/raw';
import HeroStory from '@/components/layouts/Hero/story';

const Heros = {
  basic: HeroBasic,
  home: HeroHome,
  story: HeroStory,
  project: HeroProject,
  events: HeroBasic,
  insights: HeroBasic,
  listing: HeroRaw,
  bio: HeroBio,
};

const Hero = ({ children, story, blok, type, gapBottom = 'lg' }) => {
  if (typeof Heros[type] !== 'undefined') {
    const Component = Heros[type];
    return (
      <Component story={story} blok={blok} gapBottom={gapBottom}>
        {children}
      </Component>
    );
  }
  return <Placeholder componentName={type} />;
};

export default Hero;
